import Vue from 'vue'
import Router from 'vue-router'
import DslNotice from '@/components/DslNotice'
import DslLoginQuestion from '@/components/DslLoginQuestion'
import DslPrivacyPolicy from '@/components/DslPrivacyPolicy'
import UserProvice from '@/components/UserProvice'
import PatrolStore from '@/components/PatrolStore'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'DslPrivacyPolicy',
			component: DslPrivacyPolicy
		},
		// {
		//   path: '/provision.html',
		//   name: 'DslPrivacyPolicy',
		//   component: DslPrivacyPolicy
		// },
		// {
		// 	path: '/DslNotice',
		// 	name: 'DslNotice',
		// 	component: DslNotice
		// },

		// {
		//   path: 'user_provice.html',
		//   name: 'UserProvice',
		//   component: UserProvice
		// },
		// {
		// 	path: '/PatrolStore',
		// 	name: 'PatrolStore',
		// 	component: PatrolStore
		// },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js